export const isValidPercentage = (value: string): boolean => {
  const percentage = parseInt(value)
  if (isNaN(percentage)) return false
  if (percentage < 1 || percentage > 100) return false
  return true
}
